import React from 'react'

const Disclaimer = () => {
  return (
    <div className='mt-6 text-xl ml-5 mr-5 md:ml-20 md:mr-20 md:px-32 p-4 text-justify '>
      <h1 className="text-black text-xl md:text-4xl  text-center md:px-10 font-display font-semibold md:m-8 mb-8">
          Orchid Nirvana 3.0 Disclimer
        </h1>
<p>By using or accessing the Website you agree with the Disclaimer without any qualification or limitation.
The Company reserves the right to terminate, revoke, modify, alter, add and delete any one or more of
the terms and conditions of the website. The Company shall be under no obligation to notify the visitor
of the amendment to the terms and conditions and the visitor shall be bound by such amended terms
and conditions.
</p><br/>
<p>The visuals and information contained herein marked as “artistic impression” are artistic impressions
being indicative in nature and are for general information purposes only. The visuals contained marked
as “generic image” and other visuals /image /photographs are general images and do not have any
correlation with the project.</p><br/>
<p>The imagery used on the website may not represent actuals or may be indicative of style only.
Photographs of interiors, surrounding views and location may not represent actuals or may have been
digitally enhanced or altered. These photographs may not represent actuals or may be indicative only.
Computer generated images, walkthroughs and render images are the artist's impression and are an
indicative of the actual designs.
</p><br/>
<p>No information given on this Website creates a warranty or expand the scope of any warranty that
cannot be disclaimed under the applicable laws. The information on this website is presented as
general information and no representation or warranty is expressly or impliedly given as to its
accuracy. Any interested party should verify all the information including designs, plans, specifications,
facilities, features, payment schedules, terms of sales etc. independently with the Company prior to
concluding any decision for buying in any of the project.</p><br/>
<p>While enough care is taken by the Company to ensure that information in the website are up to date,
accurate and correct, the readers/ users are requested to make an independent enquiry with the
Company before relying upon the same. Nothing on the website should be misconstrued as
advertising, marketing, booking, selling or an offer for sale or invitation to purchase a unit in any
project by the Company. The Company is not responsible for the consequences of any action taken by
the viewer relying on such material/ information on this website without independently verifying with
the Company.</p>

    </div>
  )
}

export default Disclaimer